import { type ChartSeries } from "@mantine/charts";
import { ColorSwatch, Flex, Group, Text, UnstyledButton } from "@mantine/core";
import classNames from "classnames";
import "./MantineChartLegend.scss";

interface MantineChartLegendProps {
  series: Array<ChartSeries & { color: string }>;
  inactiveSeries: Array<string>;
  onClick: (seriesId: string) => void;
  direction?: "row" | "column";
}

/*  Just like for the tooltip, Mantine doesn't allow changes to the recharts legend */
function MantineChartLegend({
  series,
  inactiveSeries,
  onClick,
  direction = "column"
}: MantineChartLegendProps) {
  return (
    <Flex
      className="ChartLegend"
      direction={direction}
      gap="md"
      mah={500}
      miw={direction === "row" ? "100%" : undefined}
      pl="md"
      w={direction === "row" ? "auto" : "20%"}
      wrap={direction === "row" ? "wrap" : "nowrap"}
    >
      {series.map((singleSeries) => {
        const isActive = !inactiveSeries.includes(singleSeries.name);
        return (
          <UnstyledButton
            className={classNames(
              "legend-item",
              isActive ? "active" : "inactive"
            )}
            key={singleSeries.name}
            onClick={() => onClick(singleSeries.name)}
          >
            <Group gap="xs" wrap="nowrap">
              <ColorSwatch
                bd={isActive ? "none" : `2px solid ${singleSeries.color}`}
                color={isActive ? singleSeries.color : "#fff"}
                size="var(--mantine-font-size-md)"
              />
              <Text
                c={!isActive ? "var(--mantine-color-neutral-3)" : undefined}
                className="legend-label"
              >
                {singleSeries.label || singleSeries.name}
              </Text>
            </Group>
          </UnstyledButton>
        );
      })}
    </Flex>
  );
}

export { MantineChartLegend };
